var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Home"},[_c('Part1',{style:(_vm.$global.moduleShowAnimation(1))}),_c('Part2',{style:(_vm.$global.moduleShowAnimation(2))}),_c('Part3',{style:(_vm.$global.moduleShowAnimation(3))}),_c('Part4',{style:(_vm.$global.moduleShowAnimation(4))})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }